export const UK_REGIONS = [
  "London",
  "South East",
  "South West",
  "East of England",
  "East Midlands",
  "West Midlands",
  "Yorkshire and the Humber",
  "North West",
  "North East",
  "Scotland",
  "Wales",
  "Northern Ireland",
];

export const US_STATES = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware",
  "District of Columbia", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas",
  "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi",
  "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York",
  "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island",
  "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington",
  "West Virginia", "Wisconsin", "Wyoming",
];

export const IE_COUNTIES = [
  "Carlow", "Cavan", "Clare", "Cork", "Donegal", "Dublin", "Galway", "Kerry", "Kildare", "Kilkenny", "Laois",
  "Leitrim", "Limerick", "Longford", "Louth", "Mayo", "Meath", "Monaghan", "Offaly", "Roscommon", "Sligo",
  "Tipperary", "Waterford", "Westmeath", "Wexford", "Wicklow",
];

export const COUNTRIES = [
  { name: "United Kingdom", short: "UK", slug: "uk", the: "the UK", regionLabel: "Region", regions: UK_REGIONS, postcodeLabel: "Postcode area", postcodeHint: "e.g. M1", currency: "gbp", price: "£10",
    cities: ["London", "Manchester", "Glasgow", "Cardiff", "Belfast", "Leeds", "Liverpool", "Bristol", "Birmingham", "Edinburgh"] },
  { name: "United States", short: "USA", slug: "usa", the: "the USA", regionLabel: "State", regions: US_STATES, postcodeLabel: "ZIP code", postcodeHint: "e.g. 90028", currency: "usd", price: "$14",
    cities: ["Los Angeles", "Atlanta", "New York", "New Orleans", "Albuquerque", "Chicago", "Austin", "Miami", "Pittsburgh", "Wilmington, NC"] },
  { name: "Ireland", short: "Ireland", slug: "ireland", the: "Ireland", regionLabel: "County", regions: IE_COUNTIES, postcodeLabel: "Eircode (optional)", postcodeHint: "e.g. D02", currency: "eur", price: "€12",
    cities: ["Dublin", "Bray", "Cork", "Galway", "Limerick", "Kilkenny", "Waterford", "Sligo", "Killarney", "Wexford"] },
];

export const countryBySlug = (slug) => COUNTRIES.find((c) => c.slug === slug);

export const countryInfo = (name) => COUNTRIES.find((c) => c.name === name) || COUNTRIES[0];

// Popular filming hubs shown on the landing page
export const HUBS = {
  "United Kingdom": ["London", "North West", "Scotland", "Wales", "South East", "Yorkshire and the Humber", "Northern Ireland", "West Midlands"],
  "United States": ["California", "New York", "Georgia", "Louisiana", "Texas", "Illinois", "New Mexico", "Florida"],
  Ireland: ["Dublin", "Wicklow", "Galway", "Cork", "Kerry", "Limerick", "Donegal", "Clare"],
};

export const GENDERS = ["Female", "Male", "Non-binary"];

export const SKILL_SUGGESTIONS = [
  "Driving licence",
  "Own car",
  "Dancing",
  "Swimming",
  "Horse riding",
  "Musician",
  "Sports",
  "Uniformed (police/military)",
  "Period costume",
  "Tattoos",
  "Stand-in",
  "Walk-on",
];
